import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  SessionLockStatus,
  type SessionLockStatusConstructor,
} from './SessionLockStatus'

export const SessionLockStatusConstructorFactory =
  Factory.Sync.makeFactory<SessionLockStatusConstructor>({
    isLocked: false,
    lockedBy: null,
  })

export const SessionLockStatusFactory = EntityFactory(
  SessionLockStatus,
  SessionLockStatusConstructorFactory
)
